import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "cfg-terminal"
  }, [_c('div', {
    staticClass: "cfg-terminal__card"
  }, [_vm._m(0), _vm.etapa === 'form' ? [_vm.erro ? _c('div', {
    staticClass: "cfg-terminal__alert cfg-terminal__alert--error",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fas fa-times-circle"
  }), _c('span', [_vm._v(_vm._s(_vm.erro))])]) : _vm._e(), _c('div', {
    staticClass: "cfg-terminal__field"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.uuid_terminal,
      expression: "form.uuid_terminal",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "cfg-terminal__input",
    class: {
      'cfg-terminal__input--error': _vm.erros.uuid_terminal
    },
    attrs: {
      "id": "cfg-uuid",
      "type": "text",
      "placeholder": "Ex.: caixa-01 ou xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
      "autocomplete": "off",
      "disabled": _vm.processando
    },
    domProps: {
      "value": _vm.form.uuid_terminal
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "uuid_terminal", $event.target.value.trim());
      }, function ($event) {
        _vm.erros.uuid_terminal = '';
        _vm.erro = '';
      }],
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _vm.erros.uuid_terminal ? _c('span', {
    staticClass: "cfg-terminal__field-error"
  }, [_vm._v(" " + _vm._s(_vm.erros.uuid_terminal) + " ")]) : _vm._e(), _vm._m(2)]), _c('div', {
    staticClass: "cfg-terminal__field"
  }, [_vm._m(3), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.device_name,
      expression: "form.device_name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "cfg-terminal__input",
    attrs: {
      "id": "cfg-device-name",
      "type": "text",
      "placeholder": "Ex.: Caixa Principal",
      "autocomplete": "off",
      "disabled": _vm.processando
    },
    domProps: {
      "value": _vm.form.device_name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "device_name", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('span', {
    staticClass: "cfg-terminal__hint"
  }, [_vm._v(" Facilita identificar o computador no painel web. ")])]), _c('button', {
    staticClass: "cfg-terminal__btn",
    attrs: {
      "type": "button",
      "disabled": _vm.processando
    },
    on: {
      "click": _vm.vincular
    }
  }, [_vm.processando ? _c('i', {
    staticClass: "fas fa-spinner fa-spin"
  }) : _c('i', {
    staticClass: "fas fa-plug"
  }), _vm._v(" " + _vm._s(_vm.processando ? "Validando..." : "Validar e configurar") + " ")])] : _vm._e(), _vm.etapa === 'sync' ? [_c('div', {
    staticClass: "cfg-terminal__sync-info"
  }, [_c('div', {
    staticClass: "cfg-terminal__sync-row"
  }, [_c('span', {
    staticClass: "cfg-terminal__sync-label"
  }, [_vm._v("Terminal")]), _c('span', {
    staticClass: "cfg-terminal__sync-value"
  }, [_vm._v(_vm._s(_vm.terminalNome))])]), _vm.terminalSerie ? _c('div', {
    staticClass: "cfg-terminal__sync-row"
  }, [_c('span', {
    staticClass: "cfg-terminal__sync-label"
  }, [_vm._v("Série NFC-e")]), _c('span', {
    staticClass: "cfg-terminal__sync-value"
  }, [_vm._v(_vm._s(_vm.terminalSerie))])]) : _vm._e()]), _c('div', {
    staticClass: "cfg-terminal__progress-wrap"
  }, [_c('div', {
    staticClass: "cfg-terminal__progress-bar"
  }, [_c('div', {
    staticClass: "cfg-terminal__progress-fill",
    style: {
      width: _vm.progresso + '%'
    }
  })]), _c('p', {
    staticClass: "cfg-terminal__progress-status"
  }, [_vm._v(_vm._s(_vm.statusSync))])]), _vm.erro ? _c('div', {
    staticClass: "cfg-terminal__alert cfg-terminal__alert--error mt-2",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fas fa-times-circle"
  }), _c('span', [_vm._v(_vm._s(_vm.erro))]), _c('div', {
    staticClass: "cfg-terminal__error-actions"
  }, [_c('button', {
    staticClass: "cfg-terminal__retry-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.tentarSync
    }
  }, [_vm._v(" Tentar novamente ")]), _c('button', {
    staticClass: "cfg-terminal__retry-btn cfg-terminal__retry-btn--ghost",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sair
    }
  }, [_vm._v(" Sair ")])])]) : _vm._e()] : _vm._e(), _vm.etapa === 'ok' ? [_vm._m(4)] : _vm._e()], 2)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "cfg-terminal__header"
  }, [_c('img', {
    staticClass: "cfg-terminal__logo",
    attrs: {
      "src": "media/brand/logo.png",
      "alt": "PDV Desktop"
    }
  }), _c('h1', {
    staticClass: "cfg-terminal__title"
  }, [_vm._v("Configuração do Terminal")]), _c('p', {
    staticClass: "cfg-terminal__subtitle"
  }, [_vm._v(" Informe o UUID do terminal liberado no painel web. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('label', {
    staticClass: "cfg-terminal__label",
    attrs: {
      "for": "cfg-uuid"
    }
  }, [_vm._v(" UUID / Código do terminal "), _c('span', {
    staticClass: "cfg-terminal__required"
  }, [_vm._v("*")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "cfg-terminal__hint"
  }, [_vm._v(" Disponível em "), _c('strong', [_vm._v("Configurações → Terminais")]), _vm._v(" no painel web. ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('label', {
    staticClass: "cfg-terminal__label",
    attrs: {
      "for": "cfg-device-name"
    }
  }, [_vm._v(" Nome deste computador "), _c('span', {
    staticClass: "cfg-terminal__optional"
  }, [_vm._v("(opcional)")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "cfg-terminal__success"
  }, [_c('div', {
    staticClass: "cfg-terminal__success-icon"
  }, [_c('i', {
    staticClass: "fas fa-check-circle"
  })]), _c('p', {
    staticClass: "cfg-terminal__success-text"
  }, [_vm._v(" Terminal configurado com sucesso! ")]), _c('p', {
    staticClass: "cfg-terminal__success-sub"
  }, [_vm._v("Abrindo o painel...")])]);
}];
export { render, staticRenderFns };